/*!
 * @utiljs/console 0.1.3 (http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/console/)
 * API http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/console/doc/api.md
 * Copyright 2017-2019 美团mfe. All Rights Reserved
 * Licensed under MIT (http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/console/LICENSE)
 */

function log(x) {
  try {
    console.log(x);
  } catch (e) {// statements
  }
}
function warn(x) {
  try {
    console.warn(x);
  } catch (e) {// statements
  }
}
function error(x) {
  try {
    console.error(x);
  } catch (e) {// statements
  }
}

export { log, warn, error };
